import { alpha } from '@mui/material/styles';

const BG_ALPHA = 0.12;

const getPaletteColor = (palette, variant) => {
  if (variant === 'error') {
    return palette.error.main;
  }

  if (variant === 'warning') {
    return palette.warning.main;
  }

  return palette.text.secondary;
};

export const getChipStyles = variant => ({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '2px 8px',
  borderRadius: '4px',
  whiteSpace: 'nowrap',
  color: ({ palette }) => getPaletteColor(palette, variant),
  backgroundColor: ({ palette }) => alpha(getPaletteColor(palette, variant), BG_ALPHA),
});
